document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('registerModal');
  const openBtn = document.getElementById('openRegisterModal');
  const closeBtn = document.getElementById('closeRegisterModal');
  const overlay = document.getElementById('modalOverlay');

  // Open modal
  if (openBtn) {
    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      modal.classList.add('active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }

  // Close modal function
  function closeModal() {
    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  // Overlay click to close
  if (overlay) {
    overlay.addEventListener('click', closeModal);
  }

  // Escape key to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
});
